import moment from 'moment-timezone'

moment.tz.getZones = function () {
    const zones = moment.tz.names()
    const zonesDisplay = []

    zones.forEach(zone => {
        const diff = moment().tz(zone).format('Z')
        const abbr = moment().tz(zone).format('z')

        zonesDisplay.push({
            label: zone + ' (' + diff + (abbr.charAt(0) != '-' && abbr.charAt(0) != '+' ? ' ' + abbr : '') + ')',
            value: zone
        })
    })

    return zonesDisplay
}
